import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M7.5 8.941A4.03 4.03 0 0 0 10.682 5h2.12v3.606h2.546v2.546h-2.545v3.817c0 .36.138.845.636 1.167q.499.322 2.121.319V19h-2.969a3.18 3.18 0 0 1-3.182-3.181v-4.667H7.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }